import React, { useContext } from 'react'
import GeoContext from 'contexts/geoContext'
import PartnershipLabel from 'components/Luxkit/Label/PartnershipLabel'
import { VIRGIN_VELOCITY_PARTNERSHIP_CODE } from 'constants/partnerships'
import { getApplicableVelocityFeatures } from 'lib/partnership/partnershipUtils'

interface Props {
  price?: number;
  type?: App.ExperienceProductType;
  variant?: 'default' | 'vendor' | 'icon';
}

function ExperiencePartnershipLabel(props: Props) {
  const { price, type, variant } = props
  const { partnership } = useContext(GeoContext)

  if (!partnership || (partnership.code !== VIRGIN_VELOCITY_PARTNERSHIP_CODE)) {
    return null
  }

  const isVelocityEnabled = partnership?.code === VIRGIN_VELOCITY_PARTNERSHIP_CODE &&
    partnership.availableForProductType.includes(type)
  const velocityFeatures = getApplicableVelocityFeatures(price ?? 0)
  return <>
    {isVelocityEnabled && <PartnershipLabel canEarn={velocityFeatures.canEarn} canUse={velocityFeatures.canBurn} variant={variant} /> }
  </>
}

ExperiencePartnershipLabel.defaultProps = {
  price: 0,
}

export default ExperiencePartnershipLabel
